import { LoginHistoryForm } from "./login-history-form";
import { LoginHistoryHandler } from "./login-history-handler";
import { LoginHistoryListener } from "./login-history-listener";
import { LoginHistoryRender } from "./login-history-render";

/**
 * Shared "Login history" modal, opened from a button next to the "Last
 * login" field on a user's profile page (account-info.blade.php). No-ops
 * when no trigger button is present on the page.
 */
export class LoginHistorySetup {
    public static init(): void {
        const form = new LoginHistoryForm();
        if (form.getTriggerButtons().length === 0) return;

        const render = new LoginHistoryRender(form);
        const handler = new LoginHistoryHandler(form, render);
        new LoginHistoryListener(form, handler).register();
    }
}
